import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';

import { useFormattedTimeAgo } from 'src/modules/homeownerApp/hooks';
import { usePartnerCobranding } from 'src/modules/homeownerApp/hooks/usePartner';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface DetailsHeadingProps {
  createdAt?: string;
}
export const DetailsHeading = ({ createdAt }: DetailsHeadingProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const dateCreated = useFormattedTimeAgo(createdAt, false);
  const partner = usePartnerCobranding();
  const heading = partner?.displayName
    ? t('share.designedWithCobrand', { orgName: partner.displayName })
    : t('share.designedWith');

  return (
    <Box flexDirection="column">
      <Heading
        noMargin
        size={{ base: 600, tablet: partner?.displayName ? 700 : 800 }}
      >
        {heading}
      </Heading>
      {dateCreated && (
        <Body
          color="neutral.secondaryText"
          fontWeight={400}
          m={0}
          mt={200}
          opacity={0.64}
          size={200}
        >
          {`${t('share.shared')} ${dateCreated?.toLowerCase()}`}
        </Body>
      )}
    </Box>
  );
};
